import React from 'react';
import { motion } from 'framer-motion';

const Travel: React.FC = () => {
  return (
    <div className="bg-gradient-to-br from-cream via-white to-blush py-12 px-4" style={{ minHeight: '100vh', paddingBottom: '20vh' }}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="page-header text-charcoal mb-4">
            Travel & Directions
          </h1>
          <p className="body-text text-gray-light">
            Everything you need to know about getting to our venue
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-8">
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center"
          >
            <h2 className="section-header text-charcoal mb-4">
              Venue Address
            </h2>
            <div className="space-y-2 body-text text-gray-700">
              <p className="font-medium">Venue Name</p>
              <p>123 Wedding Lane</p>
              <p>Beautiful Town</p>
              <p>County Name</p>
              <p>Postcode</p>
            </div>
            <button className="mt-4 text-charcoal hover-text-gold transition-colors duration-300 button-text tracking-wider bg-transparent px-6 py-3">
              Open in Google Maps
            </button>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center"
          >
            <h2 className="section-header text-charcoal mb-4">
              Parking Information
            </h2>
            <div className="body-text text-gray-700 space-y-3">
              <p>Free parking is available on-site for all guests.</p>
              <p>The venue has a large car park with space for approximately 100 cars.</p>
              <p>Additional overflow parking is available in the adjacent field if needed.</p>
              <p className="small-text text-gray-light italic">
                Please do not park on the road outside the venue.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center"
          >
            <h2 className="section-header text-charcoal mb-4">
              By Car
            </h2>
            <div className="body-text text-gray-700 space-y-3">
              <p><strong>From Dublin:</strong> Take the M4 motorway west for approximately 45 minutes.</p>
              <p><strong>From Cork:</strong> Take the M8 north, then M7 west for about 2 hours.</p>
              <p><strong>From Galway:</strong> Take the M6 east for approximately 1.5 hours.</p>
              <p className="small-text text-gray-light">
                Sat nav users: Use postcode [POSTCODE] for accurate directions.
              </p>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.5 }}
            className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg text-center"
          >
            <h2 className="section-header text-charcoal mb-4">
              Public Transport
            </h2>
            <div className="body-text text-gray-700 space-y-3">
              <p><strong>Train:</strong> Nearest station is [Station Name], approximately 15 minutes by taxi.</p>
              <p><strong>Bus:</strong> Route 123 stops at [Bus Stop] which is a 10-minute walk to the venue.</p>
              <p><strong>Taxi:</strong> Local taxi companies can be booked in advance. We recommend [Taxi Company] on [Phone Number].</p>
            </div>
          </motion.div>
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="mt-8 text-center p-6 bg-white/60 rounded-lg"
        >
          <h3 className="subheading text-charcoal mb-4">
            Need help with directions or transport?
          </h3>
          <div className="body-text text-gray-700 space-y-2">
            <p>Contact us at <a href="mailto:contact@catandri.ch" className="text-gold hover:underline">contact@catandri.ch</a></p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Travel;